"use client";

import { useEffect, useState } from "react";

const METRIC_WATCH_CACHE_RESET_EVENT = "amethyst:metric-watch-cache:reset";

/** Server-side deletions outside browser urql request a fresh client/cache generation. */
export function requestMetricWatchCacheReset(): void {
  window.dispatchEvent(new Event(METRIC_WATCH_CACHE_RESET_EVENT));
}

/**
 * Destructive server-side mutations rebuild the browser urql client so both mounted and
 * unmounted Graphcache entries are discarded before later navigation can reuse them.
 */
export function useMetricWatchCacheGeneration(): number {
  const [generation, setGeneration] = useState(0);
  useEffect(() => {
    const reset = () => setGeneration((current) => current + 1);
    window.addEventListener(METRIC_WATCH_CACHE_RESET_EVENT, reset);
    return () =>
      window.removeEventListener(METRIC_WATCH_CACHE_RESET_EVENT, reset);
  }, []);
  return generation;
}
